$( document ).ready(function() {
  console.log('Custom JS File is loading');
  if ($('section').length) {
	$('section').each(function (i, obj) {
        console.log(`section ${i}`);
        console.log($(obj).attr('aria-label'));
 	  if ($(obj).attr('aria-label').contains("Recurring") ) {                    
      		$('#deliveryAddress-collapsible .sJxop').text("For multi-address shipments - shipping addresses are selected on the cart page");
   		}
	});
  }
});